export default class StockModel {
  constructor() {
    this.stockId = '';
    this.productId = '';
    // 編號
    this.productNumber = '';
    this.count = 0;
    this.price = 0;
    this.comment = '';
    this.makeDate = '';
    // category 0: 整新品 1:維修交換品 2:維修品 3.故障品
    this.category = 0;
    // status 0:未出售 1:已出售 2:已退貨 3:故障品
    this.status = 0;
  }
}



// WEBPACK FOOTER //
// ./src/models/StockModel.js